<template>
  <v-dialog
    :model-value="verlassenDialog.offen"
    max-width="460"
    persistent
    aria-label="Ungespeicherte Änderungen"
  >
    <v-card>
      <v-card-title class="d-flex align-center ga-2">
        <v-icon icon="mdi-alert-outline" color="warning" />
        Ungespeicherte Änderungen
      </v-card-title>

      <v-card-text>
        Auf dieser Seite gibt es Eingaben, die noch nicht gespeichert sind.
        Beim Verlassen gehen sie verloren.
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <!--
          „Hierbleiben" steht zuerst und trägt die Betonung: es ist der
          ungefährliche Weg. Der Dialog erscheint ungefragt, und der schnelle
          Klick soll nicht derjenige sein, der die Arbeit verwirft.
        -->
        <v-btn
          variant="text"
          @click="antwortVerlassen(true)"
        >
          Verwerfen und verlassen
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          @click="antwortVerlassen(false)"
        >
          Hierbleiben
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
/*
 * Der Dialog wird **einmal** eingehängt (in `App.vue`) und von jeder Seite aus
 * über den Modulzustand geöffnet. So braucht ihn keine Seite selbst zu führen,
 * und zwei Seiten können ihn nicht gleichzeitig aufziehen.
 */
import { antwortVerlassen, verlassenDialog } from '@/composables/useUnsavedChanges'
</script>
